<template>
  <div class="daily">
    <el-card>
      <div class="menu-box">
        <h2>生活日记管理</h2>
        <div class="box-bd">
          <el-row :gutter="20">
            <el-col :span="4">
              <el-select
                v-model="getInfo.status"
                placeholder="状态筛选"
                clearable
                @change="search"
              >
                <el-option label="全部" :value="''"></el-option>
                <el-option label="显示" :value="1"></el-option>
                <el-option label="隐藏" :value="0"></el-option>
              </el-select>
            </el-col>
            <el-col :span="4">
              <el-input
                placeholder="请输入搜索内容"
                v-model="getInfo.info"
                clearable
                @clear="search"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="search"
                ></el-button>
              </el-input>
            </el-col>
          </el-row>
          <el-table
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            v-loading="loading"
          >
            <el-table-column prop="id" label="ID" width="80">
            </el-table-column>
            <el-table-column prop="title" label="标题" min-width="200">
            </el-table-column>
            <el-table-column prop="like" label="点赞" width="80">
            </el-table-column>
            <el-table-column prop="comment" label="评论" width="80">
            </el-table-column>
            <el-table-column prop="top" label="置顶" width="80">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.top === 1" type="danger">置顶</el-tag>
                <span v-else>否</span>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" width="100">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.status === 1" type="success">显示</el-tag>
                <el-tag v-else type="warning">隐藏</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="180">
              <template slot-scope="scope">
                {{ formatDate(scope.row.create_time) }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="300">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  icon="el-icon-search"
                  @click="openDetail(scope.row)"
                  >详情</el-button
                >
                <el-button
                  size="mini"
                  :type="scope.row.top === 1 ? 'default' : 'primary'"
                  @click="toggleTop(scope.row)"
                  >{{ scope.row.top === 1 ? '取消置顶' : '置顶' }}</el-button
                >
                <el-button
                  size="mini"
                  :type="scope.row.status === 1 ? 'danger' : 'success'"
                  @click="toggleHide(scope.row)"
                  >{{ scope.row.status === 1 ? '隐藏' : '显示' }}</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="pageChange"
            @size-change="sizeChange"
            :page-sizes="[30, 60, 100]"
            :pager-count="15"
            layout="total, sizes, prev, pager, next"
            :page-size="this.getInfo.page_num"
            background
            :total="exp.num"
          >
          </el-pagination>
        </div>
      </div>
    </el-card>
    <el-dialog
      title="日记详情"
      :before-close="handleClose"
      :visible.sync="detailDialogVisible"
      width="80%"
    >
      <el-descriptions>
        <el-descriptions-item label="标题">{{ detailInfo.title }}</el-descriptions-item>
        <el-descriptions-item label="用户ID">{{ detailInfo.user_id }}</el-descriptions-item>
        <el-descriptions-item label="点赞">{{ detailInfo.like }}</el-descriptions-item>
        <el-descriptions-item label="评论">{{ detailInfo.comment }}</el-descriptions-item>
        <el-descriptions-item label="收藏">{{ detailInfo.save_num }}</el-descriptions-item>
        <el-descriptions-item label="置顶">
          <el-tag v-if="detailInfo.top === 1" type="danger">是</el-tag>
          <span v-else>否</span>
        </el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag v-if="detailInfo.status === 1" type="success">显示</el-tag>
          <el-tag v-else type="warning">隐藏</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ formatDate(detailInfo.create_time) }}</el-descriptions-item>
        <el-descriptions-item label="内容" :span="3">
          <div style="white-space: pre-wrap;">{{ detailInfo.desc }}</div>
        </el-descriptions-item>
      </el-descriptions>
      <h3 style="margin: 20px 0 10px 0;">日记图片</h3>
      <div v-if="detailInfo.file && detailInfo.file.length > 0" style="display: flex; flex-wrap: wrap;">
        <el-image
          v-for="(item, index) in detailInfo.file"
          :key="index"
          :src="'https://erp.campgrounds.cn' + item.url"
          :preview-src-list="detailInfo.file.map(f => 'https://erp.campgrounds.cn' + f.url)"
          style="width: 150px; height: 150px; margin: 10px;"
        ></el-image>
      </div>
      <span v-else>无图片</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getNoteList,
  getNoteDetail,
  noteTop,
  noteHide,
} from '@/api/zhiqing/laobing.js'

export default {
  data() {
    return {
      loading: false,
      exp: {
        count: Number,
        num: 0,
      },
      getInfo: {
        info: '',
        status: '',
        page_code: 1,
        page_num: 15,
      },
      tableData: [],
      detailDialogVisible: false,
      detailInfo: {},
    }
  },
  computed: {},
  watch: {},
  methods: {
    formatDate(timestamp) {
      if (!timestamp) return ''
      if (typeof timestamp === 'string') {
        return timestamp
      }
      const date = new Date(timestamp * 1000)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    sizeChange(value) {
      this.getInfo.page_num = value
      this.getNoteList()
    },
    pageChange(value) {
      this.getInfo.page_code = value
      this.getNoteList()
    },
    search() {
      this.getInfo.page_code = 1
      this.getNoteList()
    },
    async openDetail(row) {
      this.detailDialogVisible = true
      try {
        const { data: res } = await getNoteDetail({ id: row.id })
        if (res.code === 0) {
          this.detailInfo = res.data
        } else {
          this.$message.error(res.message || '获取详情失败')
        }
      } catch (error) {
        this.$message.error('网络错误，请稍后重试')
      }
    },
    handleClose() {
      this.detailDialogVisible = false
      this.detailInfo = {}
    },
    async toggleTop(row) {
      const action = row.top === 1 ? '取消置顶' : '置顶'
      this.$confirm(`确认${action}该日记?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info',
      })
        .then(async () => {
          try {
            const { data: res } = await noteTop({ id: row.id })
            if (res.code === 0) {
              this.$message.success(`${action}成功！`)
              this.getNoteList()
            } else {
              this.$message.error(res.message || `${action}失败`)
            }
          } catch (error) {
            this.$message.error('网络错误，请稍后重试')
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作',
          })
        })
    },
    async toggleHide(row) {
      const action = row.status === 1 ? '隐藏' : '显示'
      this.$confirm(`确认${action}该日记?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info',
      })
        .then(async () => {
          try {
            const { data: res } = await noteHide({ id: row.id })
            if (res.code === 0) {
              this.$message.success(`${action}成功！`)
              this.getNoteList()
            } else {
              this.$message.error(res.message || `${action}失败`)
            }
          } catch (error) {
            this.$message.error('网络错误，请稍后重试')
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作',
          })
        })
    },
    async getNoteList() {
      this.loading = true
      try {
        const { data: res } = await getNoteList(this.getInfo)
        // 防御:后端可能返回 HTML(SPA fallback)或非预期 JSON 结构
        if (typeof res !== 'object' || res === null) {
          this.tableData = []
          this.exp.num = 0
          this.$message.error('后端接口未实现或返回格式异常')
          return
        }
        // 兼容多种成功状态码:0 / 200 / 1
        if (res.code === 0 || res.code === 200 || res.code === 1) {
          const list = (res.data && res.data.data) || res.data || []
          this.tableData = Array.isArray(list) ? list : []
          this.exp.num = (res.exp && res.exp.num) || (res.data && res.data.total) || 0
        } else {
          this.tableData = []
          this.exp.num = 0
          this.$message.error(res.message || `查询失败(code=${res.code})`)
        }
      } catch (error) {
        this.tableData = []
        this.exp.num = 0
        this.$message.error('网络错误或后端接口异常，请稍后重试')
      } finally {
        this.loading = false
      }
    },
  },
  mounted() {
    this.getNoteList()
  },
}
</script>
<style scoped>
.page {
  margin-top: 20px;
}
.el-pagination {
  margin-top: 20px;
  text-align: right;
}
.menu-box h2 {
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: 600;
}
.box-bd {
  margin-top: 20px;
}
</style>